export const mr = {
    nav: {
        home: "मुख्य पृष्ठ", about: "आमच्याबद्दल", products: "उत्पादने",
        contact: "संपर्क", dealerLocator: "डीलर शोधा", tagline: "गुणवत्तेशी बांधिलकी",
        getInTouch: "संपर्क साधा",
        changeLanguage: "भाषा बदला",
        openMenu: "मेनू उघडा",
        closeMenu: "मेनू बंद करा",
        homeAria: "युनिक बायोटेक रिसर्च — मुख्य पृष्ठ",
        logoAlt: "युनिक बायोटेक रिसर्च लोगो",
    },
    hero: {
        badge: "ISO 9001:2008 प्रमाणित",
        headline: "युनिक बायोटेक रिसर्च, भारतातील शेतकऱ्यांचा विश्वास.",
        sub: "२००५ पासून उत्तम शेती उत्पादनांद्वारे जास्त उत्पादन, सुदृढ माती आणि शाश्वत शेतीसाठी विश्वासार्ह स्रोत.",
        cta1: "उत्पादने पाहा", cta2: "संपर्क करा",
        highlight: "भारतातील",
        certified: "प्रमाणित",
        isoLabel: "ISO 9001:2008",
    },
    common: {
        yes: "होय",
        no: "नाही",
        previous: "मागील",
        next: "पुढील",
    },
    cookies: {
        aria: "कुकी संमती",
        title: "🍪 कुकी सूचना",
        message: "तुमचा ब्राउझिंग अनुभव सुधारण्यासाठी आम्ही कुकीज वापरतो.",
        policy: "कुकी धोरण",
        reject: "नकार द्या",
        accept: "स्वीकारा",
    },
    landing: {
        heroSub: "भारतातील शेतकऱ्यांचा विश्वास. २००५ पासून अधिक उत्पादन, निरोगी माती आणि शाश्वत शेतीसाठी गुणवत्तापूर्ण कृषी निविष्ठा.",
        heroCta1: "आमची उत्पादने पाहा",
        heroCta2: "आमच्या टीमशी बोला",
        missionEyebrow: "आमचे ध्येय",
        missionHeadingBefore: "नवकल्पनेतून",
        missionHighlight: "भारतीय शेती",
        missionHeadingAfter: "सशक्त करणे",
        missionText: "युनिक बायोटेक रिसर्चमध्ये आम्ही विज्ञान, शाश्वत शेती पद्धती आणि नाविन्यपूर्ण कृषी उपायांची सांगड घालून शेतकऱ्यांना मातीचे आरोग्य सुधारण्यास, पीक उत्पादकता वाढविण्यास आणि शेतीसाठी अधिक शाश्वत भविष्य घडविण्यास मदत करतो.",
        aboutEyebrow: "आमच्याबद्दल",
        aboutHeadingBefore: "शेतकऱ्यांसोबत वाटचाल",
        aboutHighlight: "२००५ पासून",
        aboutP1: "२००५ मध्ये पिंपळगाव बसवंत, नाशिक येथे — महाराष्ट्राच्या द्राक्ष आणि डाळिंब पट्ट्याच्या हृदयात — युनिक बायोटेक रिसर्चची सुरुवात एका साध्या ध्येयाने झाली: शेतकऱ्यांना विश्वास ठेवता येतील अशी गुणवत्तापूर्ण निविष्ठा देणे.",
        aboutP2: "दोन दशकांत आम्ही छोट्या स्थानिक उत्पादकापासून ISO-प्रमाणित कंपनीत वाढलो आहोत; १०० हून अधिक उत्पादनांसह संशोधन-आधारित कृषी उपायांद्वारे भारतातील १०,००० हून अधिक शेतकऱ्यांची सेवा करत आहोत.",
        aboutCta: "आमच्या टप्प्यांबद्दल अधिक जाणून घ्या",
        offerEyebrow: "आमची उत्पादने",
        offerHeadingBefore: "आम्ही काय",
        offerHighlight: "देतो",
        offerSub: "पीक आरोग्य सुधारण्यासाठी, उत्पादकता वाढविण्यासाठी आणि शाश्वत शेतीला पाठबळ देण्यासाठी विकसित केलेल्या आमच्या विश्वासार्ह कृषी उपायांची निवड पाहा.",
        offerCta: "अधिक उत्पादने पाहा",
        offerProducts: [
            { name: "Aminorich", line: "८०% अमिनो अॅसिड, प्रत्येक वाढ टप्प्यासाठी १८ प्रकार", category: "अमिनो अॅसिड आणि बायोस्टिम्युलंट्स" },
            { name: "Excess", line: "१२ सक्रिय प्रकारांसह उच्च शक्तीचा बायोस्टिम्युलंट", category: "अमिनो अॅसिड आणि बायोस्टिम्युलंट्स" },
            { name: "Unisearich", line: "शुद्ध अॅस्कोफिलम समुद्री शैवाल अर्क", category: "बायोस्टिम्युलंट" },
        ],
        networkEyebrow: "पॅन इंडिया नेटवर्क",
        networkHeading: "मजबूत नेटवर्क.",
        networkHighlight: "एकत्र अधिक मजबूत.",
        networkSub: "युनिक बायोटेक रिसर्च एक विश्वासार्ह देशव्यापी डीलर नेटवर्क उभारत आहे जे स्थानिक सहाय्याद्वारे शेतकऱ्यांना गुणवत्तापूर्ण कृषी उपायांशी जोडते.",
        networkCta: "डीलर व्हा",
        networkMapAria: "भारत वितरण नेटवर्क नकाशा",
        networkFeatures: [
            { title: "व्यापक पोहोच", text: "मुख्य शेती प्रदेशांमध्ये विश्वासार्ह कृषी निविष्ठांपर्यंत पोहोच वाढवणे." },
            { title: "विश्वासार्ह भागीदारी", text: "स्थानिक शेतकऱ्यांना समजणाऱ्या डीलरांसोबत दीर्घकालीन संबंध निर्माण करणे." },
            { title: "भरवशाचे सहाय्य", text: "प्रत्येक हंगामात मैदानी सहाय्य आणि वेळेवर मार्गदर्शन." },
            { title: "एकत्र वाढ", text: "गुणवत्तापूर्ण उत्पादने आणि भरवशाची सेवेने समुदायांना वाढविण्यात मदत." },
        ],
        testimonialsBadge: "शेतकरी अभिप्राय",
        testimonialsHeadingBefore: "आमचे",
        testimonialsHighlight: "शेतकरी",
        testimonialsHeadingAfter: "काय म्हणतात",
        testimonialsSub: "अधिक उत्पादन, निरोगी माती आणि मजबूत पिकांसाठी युनिक बायोटेक रिसर्चवर विश्वास ठेवणाऱ्या शेतकऱ्यांचे खरे अनुभव.",
        testimonialsPrev: "मागील अभिप्राय",
        testimonialsNext: "पुढील अभिप्राय",
        testimonialsGoTo: "अभिप्रायाकडे जा",
        stories: [
            { name: "रमेश पाटील", meta: "द्राक्ष • नाशिक", quote: "AminoRich वापरल्यानंतर बेरीचा आकार स्पष्टपणे सुधारला. माझ्या खरेदीदारांनी सलग दुसऱ्या हंगामातही प्रीमियम किंमती दिल्या." },
            { name: "सुनील देशमुख", meta: "कापूस • विदर्भ", quote: "Rhyzomax ने पावसाळ्यातील तणावातून माझे पीक सावरले. शेजारच्या शेताच्या तुलनेत मुळे स्पष्टपणे जाड होती." },
            { name: "लक्ष्मी रेड्डी", meta: "मिरची • गुंटूर", quote: "Excess च्या तीन फवारण्यांनंतर छत्र ओळखता येईनासे झाले. फांद्यांची संख्या जवळपास दुप्पट झाली आणि कापणीही." },
        ],
        ctaEyebrow: "युनिक बायोटेक रिसर्चसोबत वाढा",
        ctaHeading: "निरोगी पिके आणि अधिक उत्पादनासाठी तयार आहात?",
        ctaText: "तुमच्या माती, हंगाम आणि पिकासाठी योग्य निविष्ठा शोधण्यासाठी आमच्या कृषी तज्ज्ञांसोबत भागीदारी करा — विश्वासार्ह गुणवत्ता आणि मैदानी सहाय्यासह.",
        ctaWhatsapp: "WhatsApp वर चॅट करा",
    },
    stats: {
        years: "२०+", yearsLabel: "उत्कृष्टतेची वर्षे",
        cert: "ISO", certLabel: "९००१:२००८ प्रमाणित",
        customers: "१०,०००+", customersLabel: "समाधानी शेतकरी",
        products: "१००+", productsLabel: "उत्पादने",
    },
    home: {
        featuredLabel: "आमची उत्पादने",
        featuredTitle: "शेतीच्या प्रत्येक टप्प्यासाठी तयार केलेली कृषी उपाययोजना",
        featuredSub: "मातीच्या पोषणापासून पीक संरक्षणापर्यंत, आमची उत्पादने अनेक वर्षांच्या कृषी संशोधनातून विकसित केली आहेत, जेणेकरून शेतकऱ्यांना निरोगी पिके आणि अधिक उत्पादन मिळेल.",
        featuredNote: "2005 पासून भारतीय शेतकऱ्यांना अधिक चांगली पिके घेण्यास मदत",
        featuredExploreAll: "सर्व उत्पादने पाहा",
        featuredCards: ["जैव खते", "वनस्पती वाढ प्रवर्तक", "पीक संरक्षण", "सूक्ष्म अन्नद्रव्ये"],
        explore: "एक्सप्लोर करा",
        cropsTitle: "आम्ही सेवा देतो त्या पिकांसाठी",
        aboutLabel: "आमच्याबद्दल अधिक जाणून घ्या",
        aboutTitle: "युनिक बायोटेक रिसर्चबद्दल",
        aboutSub: "२००५ साली नाशिक, महाराष्ट्रात स्थापन झालेली आमची कंपनी भारतातील शेतकऱ्यांना सर्वोच्च दर्जाचे कृषी निविष्ठा पुरवण्यासाठी वचनबद्ध आहे.",
        aboutCta: "अधिक जाणून घ्या",
        aboutEyebrow: "युनिक बायोटेक रिसर्चबद्दल",
        aboutHeading: "नवकल्पनेतून उत्तम शेतीकडे",
        aboutHighlight: "नवकल्पनेतून",
        aboutP1: "युनिक बायोटेक रिसर्च २००५ पासून भारतीय शेतकऱ्यांची सेवा करत आहे. आम्ही नाशिक, महाराष्ट्र येथे आहोत, जो देशाच्या द्राक्ष आणि डाळिंब पट्ट्याचा केंद्रबिंदू आहे.",
        aboutP2: "आमचे काम विज्ञानावर आधारित आहे. प्रत्येक उत्पादन काळजीपूर्वक संशोधनातून तयार होते आणि शेतात पोहोचण्यापूर्वी आमच्या ISO 9001 प्रमाणित सुविधेत तपासले जाते.",
        aboutP3: "आज आम्ही सहा श्रेणींमध्ये १०० हून अधिक उत्पादने देतो. प्रत्येक उत्पादन पीक आरोग्य, अधिक उत्पादन आणि मातीची दीर्घकालीन सुपीकता यासाठी तयार केले आहे.",
        aboutBtn: "अधिक जाणून घ्या",
        aboutAchievements: [
            { title: "ISO 9001 प्रमाणित", sub: "विश्वासार्ह गुणवत्ता" },
            { title: "१००+ उत्पादने", sub: "नाविन्यपूर्ण उपाय" },
            { title: "२०+ वर्षे", sub: "शेती क्षेत्रातील अनुभव" },
        ],
        aboutFloating: [
            { title: "२०+ वर्षे", sub: "शेती क्षेत्रातील अनुभव आणि विश्वास" },
            { title: "शाश्वत शेती", sub: "उज्ज्वल भविष्यासाठी उपाय" },
            { title: "संशोधनावर आधारित", sub: "विज्ञानाधारित नवकल्पना" },
            { title: "गुणवत्तेची हमी", sub: "प्रत्येक टप्प्यावर काटेकोर गुणवत्ता" },
        ],
        aboutStatementTitle: "२००५ पासून शेतकऱ्यांसोबत वाटचाल",
        aboutStatementText: "गुणवत्ता, संशोधन आणि शाश्वत पद्धतींद्वारे नाविन्यपूर्ण जैवतंत्रज्ञान उपायांनी शेतकऱ्यांना मदत करणे.",
        ctaTitle: "तुमचे उत्पादन वाढवण्यासाठी तयार आहात?",
        ctaSub: "आमच्या कृषी तज्ज्ञांशी (Agronomists) बोला आणि तुमच्या पिकासाठी योग्य उत्पादन शोधा.",
        ctaEyebrow: "अधिक चांगले पिकवण्यासाठी तयार आहात?",
        ctaHeading: "चला एक हरित, सशक्त उद्या घडवूया.",
        ctaHighlight: "उद्या",
        ctaText: "नावीन्यपूर्ण उपाय, विश्वासार्ह गुणवत्ता आणि शाश्वत भविष्यासाठी Unik Biotech Research सोबत भागीदारी करा.",
        ctaCall: "आता कॉल करा", ctaWhatsapp: "WhatsApp",
        viewAll: "सर्व उत्पादने पाहा",
    },
    why: {
        eyebrow: "युनिक बायोटेक रिसर्च का निवडावे",
        heading: "हजारो शेतकरी युनिक बायोटेक रिसर्च का निवडतात",
        highlight: "युनिक बायोटेक रिसर्च",
        sub: "शेतकऱ्यांच्या अधिक उत्पादनासाठी आम्ही विज्ञान, नवकल्पना आणि निसर्ग यांची सांगड घालतो. पिकांचे रक्षण करणारी आणि माती निरोगी ठेवणारी विश्वासार्ह गुणवत्ता.",
        cards: [
            { title: "विज्ञानावर आधारित", desc: "प्रत्येक उत्पादन प्रगत संशोधन आणि वैज्ञानिक चाचणीतून तयार होते." },
            { title: "उच्च उत्पादन कामगिरी", desc: "स्पष्ट परिणाम देण्यासाठी आणि पीक उत्पादकता वाढवण्यासाठी तयार केलेले." },
            { title: "गुणवत्तेची हमी", desc: "प्रत्येक टप्प्यावर आंतरराष्ट्रीय मानकांनुसार कठोर गुणवत्ता नियंत्रण." },
            { title: "शाश्वत शेती", desc: "निरोगी माती, अधिक उत्पादन आणि शाश्वत भविष्यासाठी उपाय." },
            { title: "शेतकरी प्रथम दृष्टिकोन", desc: "प्रत्यक्ष शेतीतील अडचणी सोडवण्यासाठी आणि शेतकऱ्यांना मदत करण्यासाठी तयार." },
            { title: "संशोधनातून नवकल्पना", desc: "प्रभावी आणि सुरक्षित कृषी उपाय तयार करण्यासाठी सतत संशोधन." },
            { title: "आधुनिक कृषी उपाय", desc: "शेती सोपी आणि अधिक कार्यक्षम करणाऱ्या नवीन कल्पना आणि तंत्रज्ञान." },
            { title: "ISO प्रमाणित", desc: "ISO 9001:2008 प्रमाणित गुणवत्ता व्यवस्थापन प्रणालीद्वारे समर्थित." },
        ],
        stats: [
            { value: "20+", label: "उत्कृष्टतेची वर्षे" },
            { value: "100+", label: "प्रीमियम उत्पादने" },
            { value: "10,000+", label: "सेवा दिलेले शेतकरी" },
            { value: "ISO", label: "9001:2008 प्रमाणित" },
        ],
    },
    about: {
        hero: "आमच्याबद्दल",
        heroSub: "गुणवत्ता आणि नवकल्पनेसह शेतकऱ्यांची सेवा करण्याची २० वर्षे",
        missionTitle: "आमचे ध्येय",
        missionText: "शेतकऱ्यांना वैज्ञानिकदृष्ट्या प्रगत, उच्च दर्जाच्या कृषी निविष्ठांसह सशक्त करणे जे पीक आरोग्य, उत्पन्न आणि मातीची सुपीकता टिकाऊपणे सुधारतात.",
        visionTitle: "आमची दृष्टी",
        visionText: "भारतातील सर्वात विश्वासू कृषी निविष्ठा ब्रँड बनणे, आधुनिक जैवतंत्रज्ञान आणि पारंपारिक शेती ज्ञान यांना जोडणे.",
        storyLabel: "आमची मुळे",
        storyTitle: "आमची कथा",
        storyText: "महाराष्ट्राच्या द्राक्ष आणि डाळिंब पट्ट्याच्या हृदयात, नाशिकच्या पिंपळगाव बसवंत येथे २००५ मध्ये स्थापन. दोन दशकांहून अधिक काळात, आम्ही एक छोट्या स्थानिक उत्पादकापासून ISO प्रमाणित कंपनीमध्ये वाढलो आहोत. १००+ उत्पादनांसह १०,०००+ शेतकऱ्यांची सेवा करत आहोत.",
        establishedLabel: "स्थापना",
        statEstablished: "स्थापना",
        statLocation: "स्थान",
        statLocationWrap: "नाशिक, MH",
        statProducts: "उत्पादने",
        statCert: "प्रमाणपत्रे",
        statYearsWrap: "२०+ वर्षे",
        legacyLabel: "आमचा वारसा",
        journeyTitle: "यशाचे टप्पे",
        journeySub: "साध्या सुरुवातीपासून ते शेतीमधील विश्वासार्ह भागीदार होण्यापर्यंत, आमचा प्रवास विश्वास, नवकल्पना आणि प्रभाव यावर आधारित आहे.",
        growTitle: "चला एकत्र वाढूया",
        growText: "शेतकऱ्यांना नाविन्यपूर्ण उपायांनी आणि शाश्वत वाढीने सक्षम करण्याच्या आमच्या ध्येयात सहभागी व्हा.",
        growBecome: "डीलर बना",
        growFind: "डीलर शोधा",
        certTitle: "गुणवत्ता आणि प्रमाणपत्रे",
        valuesTitle: "आमची मूल्ये",
        values: [
            { title: "गुणवत्ता प्रथम", desc: "प्रत्येक उत्पादन शेतकऱ्यांपर्यंत पोहोचण्यापूर्वी कठोर गुणवत्ता तपासणीतून जाते." },
            { title: "शेतकरी केंद्रित", desc: "आमचे निर्णय शेतकऱ्यांसाठी सर्वोत्तम काय आहे यावर मार्गदर्शित आहेत." },
            { title: "नवकल्पना", desc: "आम्ही शेतकऱ्यांना नवीनतम कृषी विज्ञान आणण्यासाठी R&D मध्ये गुंतवणूक करतो." },
            { title: "विश्वास", desc: "२००५ पासून शेतकरी आणि डीलरांशी दीर्घकालीन संबंध निर्माण करणे." },
        ],
        certs: [
            { title: "ISO 9001:2008", desc: "ISO 9001:2008 प्रमाणित — गुणवत्ता व्यवस्थापन प्रणाली" },
            { title: "प्रयोगशाळेत तपासलेले", desc: "पाठवण्यापूर्वी प्रत्येक उत्पादन आमच्या प्रयोगशाळेत कठोर तपासणीतून जाते" },
            { title: "नाशिकमध्ये निर्मित", desc: "पिंपळगाव बसवंत, नाशिक, महाराष्ट्र येथे उत्पादन" },
        ],
        pageValues: [
            { title: "गुणवत्ता", desc: "गुणवत्ता आमचा पाया आहे. प्रत्येक उत्पादन काळजी आणि अचूकतेने बनवले जाते." },
            { title: "सांघिक काम", desc: "एकत्र वाढतो. आमची टीम उत्कृष्टतेसाठी सहयोगाने काम करते." },
            { title: "नवकल्पना", desc: "सतत नवकल्पनेसह शेतीच्या भविष्याचे नेतृत्व." },
            { title: "वेळेवरता", desc: "प्रत्येक वेळी वेळेवर वितरण. तुम्ही विश्वास ठेवू शकता अशी विश्वासार्हता." },
        ],
        milestones: [
            { year: "2005", title: "स्थापना", desc: "शेतकऱ्यांची सेवा करण्याच्या दृष्टीकोनातून पिंपळगाव बसवंत, नाशिक येथे युनिक बायोटेक रिसर्चची स्थापना." },
            { year: "2008", title: "मजबूत पाया", desc: "गुणवत्तापूर्ण कृषी निविष्ठांचे उत्पादन मजबूत केले आणि तळागाळात विश्वास निर्माण केला." },
            { year: "2012", title: "आणखी मजबूत", desc: "उत्पादन श्रेणी विस्तृत केली आणि महाराष्ट्रभर वितरण मजबूत केले." },
            { year: "2017", title: "हजारोचा विश्वास", desc: "हजारो शेतकऱ्यांपर्यंत पोहोचलो आणि विश्वासार्ह कृषी भागीदार बनलो." },
            { year: "2020", title: "ISO प्रमाणित", desc: "गुणवत्ता व्यवस्थापन प्रणालींसाठी ISO 9001:2008 प्रमाणन मिळवले." },
            { year: "2025+", title: "भविष्याचे रूपांतर", desc: "उज्ज्वल उद्यासाठी शाश्वत, प्रभावी आणि शेतकरी-प्रथम उपायांसह नवकल्पना सुरू." },
        ],
    },
    products: {
        title: "आमची उत्पादने",
        sub: "प्रत्येक गरजेसाठी कृषी निविष्ठांची संपूर्ण श्रेणी",
        filterLabel: "श्रेणीनुसार फिल्टर करा",
        searchLabel: "उत्पादने शोधा...",
        enquire: "चौकशी करा", viewDetails: "तपशील पाहा",
        benefits: "मुख्य फायदे", composition: "रचना",
        dosage: "मात्रा आणि वापर", form: "स्वरूप",
        packing: "पॅकिंग",
        crops: "योग्य पिके", close: "बंद करा",
        noResults: "कोणतेही उत्पादन आढळले नाही.",
        productCountLabel: "उत्पादने आढळली",
        enquireCall: "चौकशीसाठी कॉल करा: +91 7666272741",
        clearSearch: "शोध साफ करा",
        badgeMicronutrient: "सूक्ष्मपोषक",
        badgeBiostimulant: "बायोस्टिम्युलंट",
        badgeProtection: "संरक्षण",
        badgeSoil: "माती सुधारक",
        badgeBiofertilizer: "जैव खत",
        badgeSpreader: "स्प्रेडर आणि स्टिकर",
        ctaTitle: "तुम्ही जे शोधत आहात ते सापडले नाही?",
        ctaText: "तुमच्या पिकांसाठी योग्य उपाय निवडण्यात आमची टीम मदतीसाठी येथे आहे.",
        ctaBtn: "आमच्या तज्ज्ञांशी बोला",
        quickView: "जलद दृश्य",
        viewFullDetails: "पूर्ण उत्पादन पृष्ठ पाहा",
        backToProducts: "उत्पादनांकडे परत जा",
        notFoundTitle: "उत्पादन सापडले नाही",
        notFoundText: "तुम्ही शोधत असलेले उत्पादन सापडले नाही. कदाचित त्याचे नाव बदलले असेल किंवा ते यापुढे सूचीबद्ध नसेल.",
        notFoundCta: "सर्व उत्पादने पाहा",
    },
    categories: {
        all: "सर्व उत्पादने",
        micronutrient: "सूक्ष्मपोषक खते",
        biostimulant: "जैव उत्तेजक",
        protection: "पीक संरक्षण",
        soil: "माती सुधारक",
        biofertilizer: "जैव खते",
        spreader: "स्प्रेडर",
    },
    contact: {
        title: "संपर्क करा",
        sub: "अधिक निरोगी आणि उत्पादक उद्यासाठी सर्वोत्तम उपायांमध्ये मदत करण्यासाठी आम्ही येथे आहोत.",
        formTitle: "आम्हाला संदेश पाठवा",
        name: "तुमचे नाव", namePlaceholder: "पूर्ण नाव",
        phone: "फोन नंबर", phonePlaceholder: "फोन नंबर",
        email: "ईमेल (पर्यायी)", emailPlaceholder: "ईमेल पत्ता",
        cropType: "पीक प्रकार", cropPlaceholder: "तुमचे पीक निवडा",
        message: "संदेश", messagePlaceholder: "संदेश",
        subjectPlaceholder: "विषय",
        submit: "संदेश पाठवा",
        success: "संदेश यशस्वीरीत्या पाठवला! आम्ही लवकरच संपर्क करू.",
        error: "पाठवण्यात अयशस्वी. कृपया थेट कॉल करा.",
        fillError: "कृपया तुमचे नाव, फोन नंबर आणि संदेश भरा.",
        sending: "पाठवत आहे...",
        infoTitle: "संपर्क साधा",
        address: "पत्ता", phone2: "ग्राहक सेवा", emailLabel: "ईमेल", website: "वेबसाइट",
        whatsapp: "WhatsApp वर संपर्क करा",
        whatsappSub: "त्वरित प्रतिसाद मिळवा",
        addressLabel: "आमचा पत्ता",
        emailUs: "आम्हाला ईमेल करा",
        callUs: "आम्हाला कॉल करा",
        formEyebrow: "आम्हाला संदेश पाठवा",
        formHeading: "तुमच्याकडून ऐकायला आवडेल",
        formIntro: "प्रश्न, सूचना किंवा मदत हवी आहे? फॉर्म भरा आणि आमची टीम लवकरच संपर्क करेल.",
        locationEyebrow: "आमचे स्थान",
        locationHeading: "आम्हाला येथे शोधा",
        locationText: "कोणत्याही चौकशी किंवा व्यावसायिक चर्चेसाठी आमच्या कार्यालयात या. योग्य कृषी उपाय शोधण्यासाठी आमची टीम तयार आहे.",
        viewLargerMap: "मोठा नकाशा पहा",
        mapTitle: "युनिक बायोटेक रिसर्चचे स्थान",
        addressLines: [
            "Unik Biotech Research",
            "B-178, S.S. Co-Op. Ind. Estate,",
            "Pimpalgaon (B), Tal. Niphad,",
            "Dist. Nashik - 422 209,",
            "Maharashtra, India",
        ],
        mapAddressShort: "B-178, S.S. Co-Op. Ind. Estate, Pimpalgaon (B), Tal. Niphad, Dist. Nashik - 422 209, Maharashtra",
    },
    dealer: {
        title: "डीलर शोधा",
        sub: "युनिक बायोटेक रिसर्च डीलर नेटवर्कमध्ये सामील व्हा आणि शेतकऱ्यांना सक्षम करून मजबूत कृषी भविष्य घडविण्याच्या आमच्या ध्येयाचा भाग व्हा.",
        searchTitle: "डीलर शोधा",
        searchSub: "सर्वात जवळचा अधिकृत डीलर शोधण्यासाठी तुमचा जिल्हा किंवा गाव टाका",
        district: "जिल्हा", districtPlaceholder: "उदा. नाशिक, पुणे, छत्रपती संभाजीनगर",
        searchBtn: "डीलर शोधा",
        becomeTitle: "डीलर व्हा",
        becomeSub: "युनिक बायोटेक रिसर्चसोबत भागीदारी करा आणि आमची विश्वासार्ह उत्पादने, सहाय्य आणि मार्गदर्शनासह तुमचा व्यवसाय वाढवा.",
        networkTitle: "आमचे वितरण नेटवर्क",
        networkSub: "युनिक बायोटेक रिसर्चचे महाराष्ट्रभर विस्तृत डीलर नेटवर्क आहे.",
        applyName: "पूर्ण नाव", applyPhone: "फोन", applyDistrict: "जिल्हा", applyVillage: "गाव/शहर",
        applySubmit: "डीलर होण्यासाठी अर्ज करा",
        applySuccess: "अर्ज सादर केला! आमची टीम २४ तासांत संपर्क करेल.",
        applyErrSub: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.",
        applyErrFill: "कृपया नाव, मोबाइल नंबर, शहर आणि जिल्हा भरा.",
        applyErrAgree: "कृपया युनिक बायोटेक रिसर्चने संपर्क करण्यासाठी सहमती द्या.",
        applyBtnSubmitting: "पाठवत आहे...",
        namePlaceholder: "तुमचे पूर्ण नाव",
        villagePlaceholder: "गाव किंवा शहर",
        foundTitle: "तुमच्या जिल्ह्यात डीलर उपलब्ध आहे!",
        foundDesc: "अधिक माहितीसाठी कृपया आम्हाला कॉल करा: +91 7666272741",
        notFoundTitle: "तुमच्या क्षेत्रात सध्या डीलर नाही.",
        notFoundDesc: "डीलर बनण्यासाठी खाली अर्ज करा किंवा थेट कंपनीशी संपर्क करा.",
        districtsServes: "आम्ही सेवा देतो",
        headOffice: "मुख्य कार्यालय",
        benefits: [
            "तुमच्या क्षेत्रात अनन्य डीलर हक्क",
            "संपूर्ण उत्पादन प्रशिक्षण आणि तांत्रिक सहाय्य",
            "५०+ उत्पादनांवर आकर्षक मार्जिन",
            "विपणन साहित्य आणि क्षेत्रीय सहाय्य",
            "नाशिक मुख्य कार्यालयातून थेट सहाय्य"
        ],
        heroHeadingBefore: "एकत्र,",
        heroHighlight: "चांगले",
        heroHeadingAfter: "पिकवूया",
        findTitle: "डीलर शोधा",
        findSub: "तुमच्या जवळचा अधिकृत डीलर शोधा आणि तज्ज्ञ सल्ल्यासह खरे उत्पादने मिळवा.",
        applyNow: "आता अर्ज करा",
        formEyebrow: "डीलर व्हा",
        formHeading: "आमच्या डीलर नेटवर्कमध्ये सामील व्हा",
        formIntro: "युनिक बायोटेक रिसर्चसोबत भागीदारी करा आणि विश्वासार्ह कृषी उपाय, तांत्रिक सहाय्य आणि भारतभर मजबूत डीलर नेटवर्कसह तुमचा व्यवसाय वाढवा.",
        firmLabel: "व्यवसाय / फर्मचे नाव",
        firmPlaceholder: "तुमच्या व्यवसायाचे नाव",
        mobileLabel: "मोबाइल नंबर",
        emailLabel: "ईमेल पत्ता",
        cityLabel: "शहर",
        cityPlaceholder: "तुमचे शहर",
        stateLabel: "राज्य",
        selectDistrict: "जिल्हा निवडा",
        selectState: "राज्य निवडा",
        pinLabel: "पिन कोड",
        pinPlaceholder: "उदा. 422209",
        experienceLabel: "कृषी व्यवसायातील वर्षे",
        selectExperience: "अनुभव निवडा",
        productsLabel: "रुचीची उत्पादने",
        selectProducts: "उत्पादने निवडा",
        existingCustomer: "सध्याचे ग्राहक?",
        messageLabel: "अतिरिक्त संदेश",
        messagePlaceholder: "तुमचा संदेश येथे लिहा...",
        agreeText: "मी युनिक बायोटेक रिसर्चने संपर्क करण्यास सहमत आहे.",
        respondTitleBefore: "आम्ही प्रतिसाद देतो",
        respondHighlight: "२४ तासात",
        respondSub: "आमची टीम लवकरच तुमच्याशी संपर्क करेल.",
        availableEyebrow: "आमचे नेटवर्क",
        availableTitle: "उपलब्ध डीलर",
        availableSub: "खरी उत्पादने, तज्ज्ञ मार्गदर्शन आणि विश्वासार्ह कृषी उपायांसाठी जवळच्या अधिकृत युनिक बायोटेक रिसर्च डीलरशी संपर्क साधा.",
        showing: "दाखवत आहे",
        dealersCount: "डीलर",
        authorizedBadge: "अधिकृत डीलर",
        availableProducts: "उपलब्ध उत्पादने",
        callDealer: "डीलरला कॉल करा",
        directions: "दिशा",
        statsDealers: "डीलर",
        statsDistricts: "जिल्हे",
        statsYears: "वर्षांचा विश्वास",
        experienceOptions: ["१ वर्षापेक्षा कमी", "१ – ३ वर्षे", "३ – ५ वर्षे", "५ – १० वर्षे", "१०+ वर्षे"],
        productInterests: ["जैव खते", "वनस्पती वाढ प्रवर्तक", "पीक संरक्षण", "सूक्ष्म अन्नद्रव्ये", "समुद्री शैवाल अर्क", "सर्व उत्पादने"],
        faqTitle: "नेहमी विचारले जाणारे प्रश्न",
        faqSub: "अधिकृत युनिक बायोटेक डीलर होणे आणि डीलर लोकेटर वापरण्याबद्दल सामान्य प्रश्नांची उत्तरे शोधा.",
        faqs: [
            { question: "अधिकृत युनिक बायोटेक डीलर कोण होऊ शकतो?", answer: "कृषी किरकोळ विक्रेते, वितरक, कृषी-निविष्ठा व्यवसाय आणि शेती क्षेत्रातील उद्योजक अधिकृत डीलर होण्यासाठी अर्ज करू शकतात." },
            { question: "मंजुरी प्रक्रियेला किती वेळ लागतो?", answer: "अर्ज सादर केल्यानंतर आमची टीम तपासते आणि पडताळणी पूर्ण झाल्यावर पात्र अर्जदारांशी संपर्क करते." },
            { question: "कृषी उत्पादनांचा पूर्वानुभव आवश्यक आहे का?", answer: "पूर्वानुभव फायदेशीर आहे पण अनिवार्य नाही. नवीन डीलरांना उत्पादने आणि प्रक्रिया समजून घेण्यासाठी आमची टीम मार्गदर्शन करते." },
            { question: "युनिक बायोटेक डीलरांना कोणते सहाय्य देते?", answer: "डीलरांना उत्पादन माहिती, तांत्रिक मार्गदर्शन, जाहिरात सहाय्य आणि आमच्या विक्री टीमचे सहाय्य मिळते." },
            { question: "मी भारतातील कोणत्याही राज्यातून अर्ज करू शकतो का?", answer: "होय. आमच्या डीलर नेटवर्कच्या आवश्यकतांनुसार भारतभरून अर्ज स्वागतार्ह आहेत." },
            { question: "मी जवळचा डीलर कसा शोधू?", answer: "वरील डीलर लोकेटरमध्ये डीलर नाव, शहर, जिल्हा किंवा राज्याने शोधा." },
        ],
    },
    footer: {
        tagline: "गुणवत्तेशी बांधिलकी",
        desc: "दोन दशकांहून अधिक काळ भारतीय शेतकऱ्यांचा विश्वास असलेली संशोधन-आधारित कृषी उपाययोजना.",
        quickLinks: "त्वरित दुवे", productsLink: "उत्पादने", contactLink: "संपर्क",
        categories: "उत्पादन श्रेण्या", address: "पत्ता", phone: "ग्राहक सेवा",
        rights: "सर्व हक्क राखीव.",
        estLine: "स्था. २००५ | नाशिक, महाराष्ट्र, भारत",
        companyAddress: "B-178, S.S. Co-Op. Ind. Estate, Pimpalgaon (B), Tal. Niphad, Dist. Nashik - 422 209",
        journeyTitle: "आमचा प्रवास",
        contactBtn: "संपर्क करा",
        madeFor: "भारतीय शेतीसाठी बनवलेले.",
        journey: [
            { value: "20+", label: "वर्षांचा विश्वास" },
            { value: "ISO 9001:2008", label: "प्रमाणित" },
            { value: "100+", label: "उत्पादने" },
            { value: "10,000+", label: "शेतकरी" },
        ],
    },
    cookiePolicy: {
        title: "कुकी धोरण",
        subtitle: "हे पृष्ठ आमच्या वेबसाइटवर कुकीज कशा वापरल्या जाऊ शकतात याची रूपरेषा देते. अंतिम धोरण मजकूर क्लायंटद्वारे पुरवला जाईल.",
        onThisPage: "या पृष्ठावर",
        sections: [
            {
                id: "what-are-cookies",
                title: "कुकीज म्हणजे काय?",
                paragraphs: [
                    "कुकीज म्हणजे लहान मजकूर फायली असतात ज्या तुम्ही एखाद्या वेबसाइटला भेट देता तेव्हा तुमच्या डिव्हाइसवर ठेवल्या जातात. वेबसाइट अधिक कार्यक्षमतेने चालवण्यासाठी आणि साइट मालकांना माहिती देण्यासाठी त्यांचा मोठ्या प्रमाणावर वापर होतो.",
                    "जेव्हा तुम्ही आमच्या वेबसाइटला भेट देता, तेव्हा कुकीज तुमच्या संगणक, टॅबलेट किंवा मोबाइल डिव्हाइसवर संग्रहित केल्या जाऊ शकतात. या फायलींमध्ये अशी माहिती असते जी वेबसाइटला पुढील भेटींमध्ये तुमचे डिव्हाइस ओळखण्यास मदत करते.",
                    "कुकीज तुमच्या डिव्हाइसवरील इतर माहितीपर्यंत पोहोचू शकत नाहीत किंवा तुमच्या संगणकाला हानी पोहोचवत नाहीत. तुमच्या पसंती लक्षात ठेवून आणि काही साइट कार्यक्षमता सक्षम करून तुमचा ब्राउझिंग अनुभव सुधारण्यासाठी त्या तयार केल्या आहेत.",
                ],
            },
            {
                id: "why-we-use-cookies",
                title: "आम्ही कुकीज का वापरतो",
                paragraphs: [
                    "आमची वेबसाइट योग्यरित्या कार्य करते याची खात्री करण्यासाठी आणि अभ्यागत आमच्या मजकुराशी कसे संवाद साधतात हे समजून घेण्यासाठी आम्ही कुकीज वापरतो. यामुळे आमची साइट वापरणाऱ्या प्रत्येकाला अधिक चांगला अनुभव देण्यास मदत होते.",
                    "कुकीज आम्हाला तुमच्या सेटिंग्ज आणि पसंती, जसे की भाषा निवडी किंवा प्रदर्शन पर्याय, लक्षात ठेवू देतात, जेणेकरून तुम्हाला प्रत्येक भेटीत त्या पुन्हा प्रविष्ट कराव्या लागत नाहीत.",
                    "साइट रहदारी आणि वापराच्या नमुन्यांचे विश्लेषण करण्यासाठी देखील आम्ही कुकीज वापरू शकतो. ही माहिती आम्हाला आमच्या वेबसाइटची रचना, मजकूर आणि एकूण कामगिरी सुधारण्यास मदत करते.",
                    "काही कुकीज वेबसाइट चालवण्यासाठी आवश्यक असतात, तर इतर तुमचा अनुभव वाढवण्यास किंवा आमच्या मार्केटिंग प्रयत्नांना पाठिंबा देण्यास मदत करतात. तुम्ही खालील विभागांमध्ये प्रत्येक श्रेणीबद्दल अधिक जाणून घेऊ शकता.",
                ],
            },
            {
                id: "types-of-cookies",
                title: "आम्ही वापरत असलेल्या कुकीजचे प्रकार",
                paragraphs: [
                    "आम्ही आमच्या वेबसाइटवर कुकीजच्या अनेक श्रेणी वापरू शकतो. आवश्यक कुकीज मूलभूत साइट कार्यक्षमतेसाठी, जसे की नेव्हिगेशन आणि सुरक्षित क्षेत्रांमध्ये प्रवेश, आवश्यक असतात.",
                    "कामगिरी आणि विश्लेषण कुकीज पृष्ठ भेटी, रहदारी स्रोत आणि वापरकर्ता वर्तनाबद्दल निनावी माहिती गोळा करून अभ्यागत आमची वेबसाइट कशी वापरतात हे समजून घेण्यास मदत करतात.",
                    "कार्यक्षमता कुकीज वेबसाइटला तुम्ही केलेल्या निवडी लक्षात ठेवण्यास आणि सुधारित, वैयक्तिकृत वैशिष्ट्ये प्रदान करण्यास परवानगी देतात. मार्केटिंग कुकीज संबंधित मजकूर देण्यासाठी किंवा आमच्या संवादाची परिणामकारकता मोजण्यासाठी वापरल्या जाऊ शकतात.",
                ],
            },
            {
                id: "managing-preferences",
                title: "तुमच्या कुकी पसंती व्यवस्थापित करणे",
                paragraphs: [
                    "आमच्या वेबसाइटवर कुकीज कशा वापरल्या जातात याबाबत तुमच्याकडे पर्याय आहेत. बहुतेक वेब ब्राउझर तुम्हाला त्यांच्या सेटिंग्जद्वारे कुकीज नियंत्रित करण्याची परवानगी देतात, ज्यात कुकीज ब्लॉक करण्याची किंवा हटवण्याची क्षमता समाविष्ट आहे.",
                    "तुम्ही सर्व कुकीज नाकारण्यासाठी किंवा कुकी पाठवली जात असताना तुम्हाला सूचित करण्यासाठी तुमच्या ब्राउझर सेटिंग्ज समायोजित करू शकता. कृपया लक्षात घ्या की काही कुकीज अक्षम केल्याने आमच्या वेबसाइटच्या कार्यक्षमतेवर परिणाम होऊ शकतो आणि काही वैशिष्ट्ये वापरण्याची तुमची क्षमता मर्यादित होऊ शकते.",
                    "जर आमची वेबसाइट कुकी पसंती साधन देत असेल, तर तुम्ही कोणत्या पर्यायी कुकीज स्वीकारता ते सानुकूलित करण्यासाठी त्याचा वापर करू शकता. तुमच्या पसंती सहसा कोणत्याही वेळी अद्यतनित केल्या जाऊ शकतात.",
                ],
            },
            {
                id: "third-party-cookies",
                title: "तृतीय-पक्ष कुकीज",
                paragraphs: [
                    "आमच्या वेबसाइटवरील काही कुकीज आमच्या पृष्ठांवर दिसणाऱ्या तृतीय-पक्ष सेवांद्वारे सेट केल्या जाऊ शकतात. या तृतीय पक्षांमध्ये विश्लेषण प्रदाते, एम्बेड केलेले मजकूर प्लॅटफॉर्म किंवा सोशल मीडिया एकीकरणे समाविष्ट असू शकतात.",
                    "तृतीय पक्षांनी ठेवलेल्या कुकीज आम्ही नियंत्रित करत नाही, आणि त्यांचा वापर संबंधित तृतीय पक्षाच्या गोपनीयता व कुकी धोरणांद्वारे नियंत्रित होतो. अधिक माहितीसाठी आम्ही तुम्हाला त्या धोरणांचे पुनरावलोकन करण्यास प्रोत्साहित करतो.",
                    "तृतीय-पक्ष कुकीज विविध वेबसाइटवरील तुमच्या ब्राउझिंग क्रियाकलापांबद्दल माहिती गोळा करू शकतात. यामुळे त्या सेवांना त्यांच्या ऑफरचा भाग म्हणून विश्लेषण, जाहिरात किंवा इतर वैशिष्ट्ये प्रदान करण्यास मदत होते.",
                ],
            },
            {
                id: "policy-changes",
                title: "या कुकी धोरणातील बदल",
                paragraphs: [
                    "आमच्या पद्धती, तंत्रज्ञान किंवा व्यावसायिक कामकाजातील बदल दर्शवण्यासाठी आम्ही वेळोवेळी हे कुकी धोरण अद्यतनित करू शकतो. जेव्हा आम्ही बदल करतो, तेव्हा आम्ही या पृष्ठाच्या वर किंवा तळाशी दिलेली तारीख सुधारित करू.",
                    "आम्ही कुकीज कशा वापरतो याबद्दल माहिती राहण्यासाठी वेळोवेळी या धोरणाचे पुनरावलोकन करण्यास आम्ही तुम्हाला प्रोत्साहित करतो. कोणत्याही अद्यतनानंतर आमच्या वेबसाइटचा सतत वापर सुधारित धोरणाची तुमची स्वीकृती मानली जाते.",
                    "आम्ही कुकीज वापरण्याच्या पद्धतीत महत्त्वपूर्ण बदल केल्यास, आम्ही आमच्या वेबसाइटवर किंवा इतर योग्य माध्यमांद्वारे अतिरिक्त सूचना देऊ शकतो.",
                ],
            },
            {
                id: "contact-us",
                title: "संपर्क करा",
                paragraphs: [
                    "या कुकी धोरणाबद्दल किंवा आम्ही आमच्या वेबसाइटवर कुकीज कशा वापरतो याबद्दल तुमचे काही प्रश्न असल्यास, कृपया आमच्या वेबसाइटवर दिलेल्या तपशिलांचा वापर करून आमच्याशी संपर्क साधा.",
                    "आम्ही तुमच्या चौकशींना शक्य तितक्या लवकर प्रतिसाद देऊ आणि कुकीज किंवा तुमच्या गोपनीयता पसंतींशी संबंधित कोणत्याही चिंतेत मदत करण्यास आनंदित होऊ.",
                    "आम्ही वैयक्तिक डेटा कसा हाताळतो याबद्दल सामान्य माहितीसाठी, तुम्ही आमच्या गोपनीयता धोरणाचा संदर्भ देखील घेऊ शकता, जे आमच्या वेबसाइटवर उपलब्ध आहे.",
                ],
            },
        ],
    },
    privacyPolicy: {
        title: "गोपनीयता धोरण",
        subtitle: "हे पृष्ठ वर्णन करते की तुम्ही आमच्या वेबसाइटला भेट देता किंवा ऑनलाइन आमच्याशी संवाद साधता तेव्हा आम्ही वैयक्तिक माहिती कशी गोळा, वापर आणि संरक्षित करू शकतो.",
        onThisPage: "या पृष्ठावर",
        sections: [
            {
                id: "introduction",
                title: "परिचय",
                paragraphs: [
                    "हे गोपनीयता धोरण वर्णन करते की तुम्ही आमच्या वेबसाइटला भेट देता, आमच्याशी संपर्क साधता किंवा आमच्या सेवांशी संवाद साधता तेव्हा आम्ही वैयक्तिक माहिती कशी गोळा, वापर आणि हाताळू शकतो. वैयक्तिक डेटासंबंधी आमच्या सामान्य पद्धती समजून घेण्यासाठी आम्ही तुम्हाला हे पृष्ठ वाचण्यास प्रोत्साहित करतो.",
                    "आमची वेबसाइट वापरून किंवा आम्हाला माहिती देऊन, तुम्ही मान्य करता की तुमची वैयक्तिक माहिती या धोरणात वर्णन केल्याप्रमाणे प्रक्रिया केली जाऊ शकते. जर तुम्ही या पद्धतींशी सहमत नसाल, तर तुम्ही आमची वेबसाइट न वापरण्याचा किंवा आमच्या फॉर्मद्वारे वैयक्तिक माहिती न देण्याचा पर्याय निवडू शकता.",
                    "हे धोरण आमच्या वेबसाइट आणि संबंधित ऑनलाइन माध्यमांद्वारे गोळा केलेल्या माहितीवर लागू होते. आमच्या साइटशी लिंक होणाऱ्या तृतीय-पक्ष वेबसाइटद्वारे किंवा ऑफलाइन गोळा केलेली माहिती यात समाविष्ट नाही.",
                ],
            },
            {
                id: "information-we-collect",
                title: "आम्ही कोणती माहिती गोळा करतो",
                paragraphs: [
                    "तुम्ही संपर्क फॉर्म भरता, माहिती मागता, अद्यतनांची सदस्यता घेता किंवा अन्यथा आमच्याशी संवाद साधता तेव्हा तुम्ही स्वेच्छेने दिलेली माहिती आम्ही गोळा करू शकतो. यात तुमचे नाव, ईमेल पत्ता, फोन नंबर, कंपनीचे नाव आणि तुमच्या संदेशाचा मजकूर समाविष्ट असू शकतो.",
                    "तुम्ही आमच्या वेबसाइटला भेट देता तेव्हा, आम्ही काही तांत्रिक माहिती आपोआप गोळा करू शकतो, जसे की तुमचा ब्राउझर प्रकार, डिव्हाइस प्रकार, ऑपरेटिंग सिस्टम, IP पत्ता, संदर्भित URL आणि तुम्ही आमच्या पृष्ठांशी कसे संवाद साधता याबद्दलचा सामान्य वापर डेटा.",
                    "आमची वेबसाइट चालवण्यास मदत करणाऱ्या तृतीय-पक्ष सेवा प्रदात्यांकडून, जसे की विश्लेषण किंवा होस्टिंग सेवा, आम्हाला माहिती मिळू शकते. गोळा केलेल्या माहितीचे प्रकार वापरलेल्या सेवा आणि तुमच्या ब्राउझर सेटिंग्जवर अवलंबून असतात.",
                    "तुम्ही एखाद्या संदेशात किंवा फॉर्म सबमिशनमध्ये संवेदनशील वैयक्तिक माहिती समाविष्ट करण्याचे निवडल्याशिवाय आम्ही ती जाणीवपूर्वक गोळा करत नाही. कृपया आमच्या वेबसाइटद्वारे तुम्हाला शेअर करू इच्छित नसलेली माहिती पाठवणे टाळा.",
                ],
            },
            {
                id: "how-we-use-your-information",
                title: "आम्ही तुमची माहिती कशी वापरतो",
                paragraphs: [
                    "तुमच्या चौकशींना प्रतिसाद देण्यासाठी, मागितलेली माहिती पुरवण्यासाठी आणि जिथे योग्य असेल तिथे आमची उत्पादने, सेवा किंवा अद्यतनांबद्दल तुमच्याशी संवाद साधण्यासाठी आम्ही गोळा केलेली माहिती वापरू शकतो.",
                    "तांत्रिक आणि वापर माहिती आमची वेबसाइट राखण्यासाठी आणि सुधारण्यासाठी, अभ्यागतांच्या पसंती समजून घेण्यासाठी, कामगिरीचे निरीक्षण करण्यासाठी आणि आमच्या प्रेक्षकांशी संबंधित मजकूर विकसित करण्यास मदत करण्यासाठी वापरली जाऊ शकते.",
                    "आम्ही गोळा केलेली माहिती अंतर्गत व्यावसायिक हेतूंसाठी देखील वापरू शकतो, जसे की नोंदी ठेवणे, गुणवत्ता पुनरावलोकन आणि आमच्या ऑनलाइन उपस्थितीचे सामान्य प्रशासन.",
                    "आम्ही सहसा आमच्या वेबसाइटशी तुमचा संवाद, आमच्या सेवा चालवण्यात व सुधारण्यात आमचे कायदेशीर व्यावसायिक हित, आणि जिथे लागू असेल तिथे तुमची संमती यांच्या आधारे माहिती प्रक्रिया करतो.",
                ],
            },
            {
                id: "cookies-and-tracking",
                title: "कुकीज आणि ट्रॅकिंग तंत्रज्ञान",
                paragraphs: [
                    "आमची वेबसाइट पसंती लक्षात ठेवण्यासाठी, मूलभूत साइट कार्यक्षमतेला पाठिंबा देण्यासाठी आणि अभ्यागत आमची पृष्ठे कशी वापरतात याबद्दल माहिती गोळा करण्यासाठी कुकीज आणि तत्सम तंत्रज्ञान वापरू शकते.",
                    "कुकीज म्हणजे तुमच्या ब्राउझरद्वारे तुमच्या डिव्हाइसवर संग्रहित केलेल्या लहान मजकूर फायली. त्या सत्र कुकीज असू शकतात, ज्या तुम्ही ब्राउझर बंद केल्यावर संपतात, किंवा स्थायी कुकीज, ज्या संपेपर्यंत किंवा हटवल्या जाईपर्यंत राहतात.",
                    "तुम्ही सहसा तुमच्या ब्राउझर सेटिंग्जद्वारे कुकीज व्यवस्थापित किंवा अक्षम करू शकता. कृपया लक्षात घ्या की कुकीज मर्यादित केल्याने आमच्या वेबसाइटच्या काही वैशिष्ट्यांवर किंवा एकूण अनुभवावर परिणाम होऊ शकतो.",
                    "जिथे आम्ही विश्लेषण किंवा तत्सम साधने वापरतो, त्या सेवा रहदारीचे नमुने आणि साइट वापर समजून घेण्यास मदत करण्यासाठी एकत्रित किंवा डिव्हाइस-स्तरीय माहिती गोळा करू शकतात. त्यांचा वापर त्यांच्या स्वतःच्या धोरणांच्या अधीन आहे.",
                ],
            },
            {
                id: "data-sharing",
                title: "डेटा सामायिकरण आणि तृतीय-पक्ष सेवा",
                paragraphs: [
                    "आम्ही वैयक्तिक माहिती विकत नाही. आमची वेबसाइट चालवण्यात, मजकूर होस्ट करण्यात, संवाद पोहोचवण्यात किंवा साइट कामगिरीचे विश्लेषण करण्यात मदत करणाऱ्या विश्वसनीय सेवा प्रदात्यांसोबत आम्ही माहिती सामायिक करू शकतो.",
                    "हे प्रदाते आमच्या वतीने माहिती प्रक्रिया करू शकतात आणि सहसा त्यांच्याकडून अपेक्षा असते की ते तिचा वापर केवळ ते आमच्यासाठी करत असलेल्या सेवांसाठीच करतील. लागू कायदा, नियमन, कायदेशीर प्रक्रिया किंवा सरकारी विनंतीनुसार आवश्यक असल्यास आम्ही माहिती सामायिक करू शकतो.",
                    "आमच्या वेबसाइटमध्ये आमच्याद्वारे चालवल्या न जाणाऱ्या बाह्य वेबसाइट किंवा सेवांचे दुवे असू शकतात. त्या तृतीय पक्षांच्या गोपनीयता पद्धतींसाठी आम्ही जबाबदार नाही, आणि वैयक्तिक माहिती देण्यापूर्वी त्यांच्या धोरणांचे पुनरावलोकन करण्यास आम्ही तुम्हाला प्रोत्साहित करतो.",
                    "विलीनीकरण, अधिग्रहण किंवा पुनर्रचना यांसारख्या व्यावसायिक बदलाच्या प्रसंगी, वैयक्तिक माहिती त्या व्यवहाराचा भाग म्हणून हस्तांतरित केली जाऊ शकते, जी लागू आवश्यकतांच्या अधीन असेल.",
                ],
            },
            {
                id: "data-security",
                title: "डेटा सुरक्षा",
                paragraphs: [
                    "वैयक्तिक माहितीचे अनधिकृत प्रवेश, प्रकटीकरण, बदल किंवा हानीपासून संरक्षण करण्यासाठी तयार केलेले वाजवी प्रशासकीय, तांत्रिक आणि संस्थात्मक उपाय आम्ही अवलंबतो.",
                    "तथापि, इंटरनेटवरील प्रसारणाची कोणतीही पद्धत किंवा इलेक्ट्रॉनिक संग्रहणाची कोणतीही पद्धत पूर्णपणे सुरक्षित नाही. माहितीचे रक्षण करण्यासाठी आम्ही काम करत असलो तरी, आमच्याकडे प्रसारित किंवा संग्रहित केलेल्या डेटाची संपूर्ण सुरक्षा आम्ही सुनिश्चित करू शकत नाही.",
                    "जिथे लागू असेल तिथे, आमच्या सेवांच्या तुमच्या वापराशी संबंधित कोणतेही क्रेडेन्शियल्स किंवा प्रवेश तपशील गोपनीय ठेवण्यासाठी तुम्ही जबाबदार आहात.",
                    "जर तुम्हाला वाटत असेल की आमच्याशी तुमचा संवाद यापुढे सुरक्षित नाही, तर कृपया खाली दिलेल्या तपशिलांचा वापर करून आमच्याशी संपर्क साधा जेणेकरून आम्ही या बाबीचे पुनरावलोकन करू शकू.",
                ],
            },
            {
                id: "your-rights",
                title: "तुमचे अधिकार",
                paragraphs: [
                    "तुमचे स्थान आणि लागू कायद्यानुसार, आमच्याकडे असलेल्या तुमच्या वैयक्तिक माहितीसंबंधी तुमच्याकडे काही पर्याय असू शकतात. यात तुमच्या माहितीत प्रवेश, दुरुस्ती किंवा हटवण्याची विनंती करण्याची क्षमता समाविष्ट असू शकते.",
                    "त्या संदेशांतील सदस्यता रद्द करण्याच्या सूचनांचे पालन करून किंवा थेट आमच्याशी संपर्क साधून तुम्ही आमच्याकडून मार्केटिंग संवाद प्राप्त करण्यापासून ऑप्ट आउट देखील करू शकता.",
                    "तुमच्या वैयक्तिक माहितीशी संबंधित विनंती सादर करण्यासाठी, कृपया या धोरणात दिलेल्या संपर्क तपशिलांचा वापर करा. काही विनंत्यांना प्रतिसाद देण्यापूर्वी आम्हाला तुमची ओळख पडताळण्याची आवश्यकता असू शकते.",
                    "आम्ही लागू कायदेशीर आवश्यकता आणि आमच्या अंतर्गत प्रक्रियांनुसार विनंत्यांचा विचार करू आणि त्यांना प्रतिसाद देऊ.",
                ],
            },
            {
                id: "policy-changes",
                title: "या गोपनीयता धोरणातील बदल",
                paragraphs: [
                    "आमच्या पद्धती, सेवा किंवा परिचालन गरजांमधील बदल दर्शवण्यासाठी आम्ही वेळोवेळी हे गोपनीयता धोरण अद्यतनित करू शकतो. जेव्हा आम्ही बदल करतो, तेव्हा आम्ही प्रभावी तारीख सुधारित करू किंवा या पृष्ठावर अद्यतनित आवृत्ती पोस्ट करू.",
                    "आम्ही वैयक्तिक माहिती कशी हाताळू शकतो याबद्दल माहिती राहण्यासाठी वेळोवेळी या धोरणाचे पुनरावलोकन करण्यास आम्ही तुम्हाला प्रोत्साहित करतो. बदल पोस्ट झाल्यानंतर आमच्या वेबसाइटचा सतत वापर अद्यतनित धोरणाची तुमची स्वीकृती दर्शवू शकतो.",
                    "वैयक्तिक माहिती हाताळण्याच्या पद्धतीवर लक्षणीय परिणाम करणारे भौतिक बदल आम्ही केल्यास, आम्ही जिथे योग्य असेल तिथे अतिरिक्त सूचना देऊ शकतो.",
                ],
            },
            {
                id: "contact-us",
                title: "संपर्क करा",
                paragraphs: [
                    "या गोपनीयता धोरणाबद्दल किंवा आम्ही वैयक्तिक माहिती कशी हाताळतो याबद्दल तुमचे काही प्रश्न असल्यास, कृपया आमच्या वेबसाइटवर उपलब्ध संपर्क पर्यायांचा वापर करून आमच्याशी संपर्क साधा.",
                    "संपर्क साधताना, कृपया पुरेसा तपशील समाविष्ट करा जेणेकरून आम्ही तुमची चौकशी समजून घेऊ आणि तिला प्रतिसाद देऊ शकू. आम्ही वाजवी विनंत्यांचे वेळेवर पुनरावलोकन व निराकरण करण्याचे उद्दिष्ट ठेवतो.",
                    "सामान्य व्यावसायिक चौकशीसाठी, तुम्ही आमच्या वेबसाइटवर सूचीबद्ध संपर्क माहिती देखील वापरू शकता. आमच्या गोपनीयता पद्धतींमधील तुमच्या स्वारस्याचे आम्ही कौतुक करतो आणि तुमच्या अभिप्रायाचे स्वागत करतो.",
                ],
            },
        ],
    },
    terms: {
        title: "नियम आणि अटी",
        subtitle: "हे नियम या वेबसाइटवरील प्रवेश आणि वापर नियंत्रित करतात. कृपया आमची साइट वापरण्यापूर्वी ते काळजीपूर्वक वाचा.",
        onThisPage: "या पृष्ठावर",
        sections: [
            {
                id: "introduction",
                title: "परिचय",
                paragraphs: [
                    "हे नियम आणि अटी या वेबसाइटवरील तुमचा प्रवेश आणि वापर नियंत्रित करतात. आमच्या साइटला भेट देऊन किंवा तिचा वापर करून, तुम्ही या नियमांनी आणि आमच्या संबंधित धोरणांनी बांधील राहण्यास सहमत होता.",
                    "ही वेबसाइट सामान्य माहितीच्या हेतूंसाठी पुरवली आहे. या साइटवरील मजकूर आमचा व्यवसाय, उत्पादने, सेवा आणि आमच्या अभ्यागतांसाठी स्वारस्याचे इतर विषय वर्णन करू शकतो.",
                    "कृपया वेबसाइट वापरण्यापूर्वी हे नियम काळजीपूर्वक वाचा. जर तुम्ही या नियमांच्या कोणत्याही भागाशी सहमत नसाल, तर तुम्ही साइटचा वापर थांबवावा.",
                ],
            },
            {
                id: "acceptance-of-terms",
                title: "नियमांची स्वीकृती",
                paragraphs: [
                    "या वेबसाइटवर प्रवेश करून किंवा तिचा वापर करून, तुम्ही पुष्टी करता की तुम्ही हे नियम आणि अटी वाचल्या, समजून घेतल्या आहेत आणि त्यांना सहमत आहात. साइटचा तुमचा सतत वापर या नियमांची निरंतर स्वीकृती दर्शवतो.",
                    "जर तुम्ही एखाद्या संस्थेच्या वतीने ही वेबसाइट वापरत असाल, तर तुम्ही प्रतिनिधित्व करता की त्या संस्थेला या नियमांनी बांधण्याचा अधिकार तुमच्याकडे आहे.",
                    "आम्ही वेळोवेळी हे नियम अद्यतनित करू शकतो. जेव्हा बदल पोस्ट केले जातात, तेव्हा वेबसाइटचा तुमचा सतत वापर सुधारित नियमांची तुमची स्वीकृती दर्शवू शकतो.",
                ],
            },
            {
                id: "use-of-the-website",
                title: "वेबसाइटचा वापर",
                paragraphs: [
                    "तुम्ही ही वेबसाइट कायदेशीर हेतूंसाठी आणि या नियमांशी सुसंगत पद्धतीने वापरू शकता. साइटचा वापर अशा कोणत्याही प्रकारे न करण्यास तुम्ही सहमत होता ज्यामुळे तिच्या कामकाजाला हानी, अक्षमता, अतिभार किंवा बाधा येऊ शकेल.",
                    "तुम्ही वेबसाइट, संबंधित प्रणाली किंवा नेटवर्कच्या कोणत्याही भागात अनधिकृत प्रवेश मिळवण्याचा प्रयत्न करू शकत नाही. साइट किंवा तिच्या मजकुराच्या सुरक्षा किंवा अखंडतेत हस्तक्षेप न करण्यासही तुम्ही सहमत होता.",
                    "साइटचा वापर या नियमांचे उल्लंघन करतो किंवा साइट किंवा इतर वापरकर्त्यांसाठी धोका निर्माण करतो असे आम्हाला वाटल्यास, कोणत्याही वेळी, सूचनेसह किंवा सूचनेशिवाय, वेबसाइटवरील प्रवेश मर्यादित किंवा समाप्त करण्याचा अधिकार आम्ही राखून ठेवतो.",
                    "या वेबसाइटवरील माहिती सामान्य आधारावर पुरवली जाते आणि पूर्वसूचनेशिवाय बदलली किंवा अद्यतनित केली जाऊ शकते. साइट नेहमी उपलब्ध राहील किंवा त्रुटी किंवा व्यत्ययांपासून मुक्त असेल याची आम्ही हमी देत नाही.",
                ],
            },
            {
                id: "intellectual-property",
                title: "बौद्धिक संपदा",
                paragraphs: [
                    "या वेबसाइटवरील सर्व मजकूर, ज्यात मजकूर, ग्राफिक्स, लोगो, प्रतिमा, मांडणी आणि इतर साहित्य समाविष्ट आहे, आमच्या मालकीचे आहे किंवा परवानगीने वापरले जाते आणि लागू बौद्धिक संपदा कायद्यांद्वारे संरक्षित आहे.",
                    "लेखी स्वरूपात अन्यथा परवानगी दिल्याशिवाय, तुम्ही या वेबसाइटवरील मजकूर केवळ वैयक्तिक, गैर-व्यावसायिक वापरासाठी पाहू आणि डाउनलोड करू शकता. पूर्व अधिकृततेशिवाय तुम्ही साइट मजकूराची प्रतिलिपी, पुनरुत्पादन, वितरण, बदल किंवा व्युत्पन्न कामे तयार करू शकत नाही.",
                    "या वेबसाइटवर प्रदर्शित ट्रेडमार्क, सेवा चिन्हे आणि व्यापार नावे संबंधित मालकाच्या पूर्व लेखी संमतीशिवाय वापरली जाऊ शकत नाहीत.",
                    "या वेबसाइटवरील कोणत्याही साहित्याचा अनधिकृत वापर कॉपीराइट, ट्रेडमार्क किंवा इतर लागू कायद्यांचे उल्लंघन करू शकतो आणि त्याचा परिणाम कायदेशीर कारवाईत होऊ शकतो.",
                ],
            },
            {
                id: "user-responsibilities",
                title: "वापरकर्त्याच्या जबाबदाऱ्या",
                paragraphs: [
                    "या वेबसाइटद्वारे तुम्ही सादर केलेली कोणतीही माहिती अचूक, पूर्ण आणि योग्य आहे याची खात्री करण्यासाठी तुम्ही जबाबदार आहात. तुम्ही खोटा, दिशाभूल करणारा किंवा बेकायदेशीर मजकूर सादर न करण्यास सहमत होता.",
                    "जर तुम्ही या साइटवरून लिंक केलेल्या फॉर्म, ईमेल किंवा इतर माध्यमांद्वारे आमच्याशी संपर्क साधलात, तर तुम्ही आदरपूर्वक संवाद साधण्यास आणि हानिकारक, आक्षेपार्ह किंवा अनधिकृत साहित्य प्रसारित न करण्यास सहमत होता.",
                    "जिथे लागू असेल तिथे, आमच्या सेवांच्या तुमच्या वापराशी संबंधित कोणतेही खाते क्रेडेन्शियल्स किंवा प्रवेश तपशील गोपनीय ठेवण्यासाठी तुम्ही जबाबदार आहात.",
                    "ही वेबसाइट वापरताना आणि आम्ही पुरवत असलेल्या कोणत्याही ऑनलाइन माध्यमांद्वारे आमच्याशी संवाद साधताना तुम्ही सर्व लागू कायदे व नियमांचे पालन करण्यास सहमत होता.",
                ],
            },
            {
                id: "limitation-of-liability",
                title: "दायित्वाची मर्यादा",
                paragraphs: [
                    "ही वेबसाइट आणि तिचा मजकूर 'जसा आहे' आणि 'जसा उपलब्ध आहे' या आधारावर पुरवला जातो. लागू कायद्याने परवानगी दिलेल्या पूर्ण मर्यादेपर्यंत, आम्ही साइट आणि तिच्या मजकुरासंबंधी सर्व हमी नाकारतो, मग त्या स्पष्ट असोत किंवा निहित.",
                    "वेबसाइट अखंडित, त्रुटी-मुक्त, सुरक्षित किंवा व्हायरस किंवा इतर हानिकारक घटकांपासून मुक्त असेल याची आम्ही हमी देत नाही. तुम्ही साइटचा वापर तुमच्या स्वतःच्या जोखमीवर करता.",
                    "लागू कायद्याने परवानगी दिलेल्या कमाल मर्यादेपर्यंत, या वेबसाइटच्या तुमच्या वापरातून उद्भवणाऱ्या किंवा त्याच्याशी संबंधित कोणत्याही अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी किंवा दंडात्मक हानीसाठी आम्ही जबाबदार राहणार नाही.",
                    "जिथे असे वगळणे किंवा मर्यादा लागू कायद्याने परवानगी नाही, तिथे या नियमांतील काहीही दायित्व वगळत किंवा मर्यादित करत नाही.",
                ],
            },
            {
                id: "third-party-links",
                title: "तृतीय-पक्ष दुवे",
                paragraphs: [
                    "या वेबसाइटमध्ये आमच्या मालकीच्या किंवा नियंत्रणाखाली नसलेल्या तृतीय-पक्ष वेबसाइट किंवा सेवांचे दुवे असू शकतात. हे दुवे केवळ सोयीसाठी आणि माहितीच्या हेतूंसाठी पुरवले आहेत.",
                    "कोणत्याही तृतीय-पक्ष साइट किंवा सेवांच्या मजकूर, धोरणे, पद्धती किंवा उपलब्धतेचे आम्ही समर्थन करत नाही आणि त्यांच्यासाठी जबाबदार नाही. तृतीय-पक्ष वेबसाइटचा तुमचा वापर तुमच्या स्वतःच्या विवेकबुद्धीने आणि जोखमीवर आहे.",
                    "तुम्ही भेट देणाऱ्या कोणत्याही तृतीय-पक्ष वेबसाइटच्या नियम आणि गोपनीयता धोरणांचे पुनरावलोकन करण्यास आम्ही तुम्हाला प्रोत्साहित करतो. तृतीय-पक्ष मजकूर किंवा सेवांच्या तुमच्या वापरातून किंवा त्यांवरील अवलंबनातून उद्भवणाऱ्या कोणत्याही हानी किंवा नुकसानीसाठी आम्ही जबाबदार नाही.",
                ],
            },
            {
                id: "changes-to-these-terms",
                title: "या नियमांतील बदल",
                paragraphs: [
                    "आमची वेबसाइट, व्यावसायिक पद्धती किंवा कायदेशीर आवश्यकतांमधील बदल दर्शवण्यासाठी आम्ही कोणत्याही वेळी हे नियम आणि अटी सुधारित करू शकतो. अद्यतनित नियम, जिथे लागू असेल तिथे, सुधारित प्रभावी तारखेसह या पृष्ठावर पोस्ट केले जातील.",
                    "या नियमांचे वेळोवेळी पुनरावलोकन करणे ही तुमची जबाबदारी आहे. बदल पोस्ट झाल्यानंतर वेबसाइटचा सतत वापर अद्यतनित नियमांची तुमची स्वीकृती दर्शवू शकतो.",
                    "आम्ही भौतिक बदल केल्यास, आम्ही जिथे योग्य असेल तिथे वेबसाइटवर किंवा इतर वाजवी माध्यमांद्वारे अतिरिक्त सूचना देऊ शकतो.",
                ],
            },
            {
                id: "governing-law",
                title: "शासित कायदा",
                paragraphs: [
                    "हे नियम आणि अटी कायद्याच्या संघर्षाच्या तत्त्वांचा विचार न करता, लागू कायद्यांद्वारे शासित आणि त्यानुसार व्याख्यायित केले जातील.",
                    "या नियमांतून किंवा या वेबसाइटच्या तुमच्या वापरातून उद्भवणारा किंवा त्याच्याशी संबंधित कोणताही वाद लागू कायद्याने नियुक्त केलेल्या न्यायालये किंवा न्यायाधिकरणांच्या अधिकारक्षेत्राच्या अधीन असेल.",
                    "या नियमांची कोणतीही तरतूद अवैध किंवा अंमलात न आणण्याजोगी आढळल्यास, उर्वरित तरतुदी लागू कायद्याने परवानगी दिलेल्या मर्यादेपर्यंत पूर्ण बल आणि प्रभावात राहतील.",
                ],
            },
            {
                id: "contact-us",
                title: "संपर्क करा",
                paragraphs: [
                    "या नियम आणि अटींबद्दल किंवा या वेबसाइटच्या तुमच्या वापराबद्दल तुमचे काही प्रश्न असल्यास, कृपया आमच्या वेबसाइटवर उपलब्ध संपर्क पर्यायांचा वापर करून आमच्याशी संपर्क साधा.",
                    "संपर्क साधताना, कृपया पुरेसा तपशील समाविष्ट करा जेणेकरून आम्ही तुमची चौकशी समजून घेऊ आणि तिला प्रतिसाद देऊ शकू. आम्ही वाजवी विनंत्यांचे वेळेवर पुनरावलोकन व निराकरण करण्याचे उद्दिष्ट ठेवतो.",
                    "सामान्य व्यावसायिक चौकशीसाठी, तुम्ही आमच्या वेबसाइटवर सूचीबद्ध संपर्क माहिती देखील वापरू शकता. तुमच्या स्वारस्याचे आम्ही कौतुक करतो आणि तुमच्या अभिप्रायाचे स्वागत करतो.",
                ],
            },
        ],
    },
    crops: ["द्राक्ष", "डाळिंब", "केळी", "कापूस", "टोमॅटो", "सोयाबीन", "ऊस", "भाजीपाला", "कांदा", "मिरची", "इतर"],
};
